
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { StorageService } from '../../storageprovider';
import { delay, map, tap } from 'rxjs/operators';
import { IVideoService } from './ivideo.service';
import { Utility } from '../utility';

@Injectable()
export class VideoService implements IVideoService {
    constructor(
        // private httpClient: HttpClient,
        private _videoTransFormer: VideoTransFormer,
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _storage: StorageService,
        private _utility:Utility
    ) { }

    getDownloadLink(viewModel): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-downloadlink', viewModel);

        return this._httpClientHelper.get(apiURL)
        //   .pipe(catchError((error: any) => observableThrowError('Server error: getVideo: ' + error)));
    }

    /*播放下一集 */
    playNextVideo(viewModel): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('video-playnext', viewModel);
        return this._httpClientHelper.get(apiURL)
        //.pipe(catchError((error: any) => observableThrowError('Server error: getVideo: ' + error)));

    }

    /*过滤广告 */
    filterVideo(user, vid): Observable<any> {
        let params = {
            id: vid,
        };

        const apiURL = this._apiUrlHelper.urlBuilder('video-filter', params);
        return this._httpClientHelper.get(apiURL)
    }
    /*
    ** 用户是否已购买了视频广告过滤
    */
    IsUserFilter(user, id): Observable<any> {

        let params;
        if (user) {
            params = {
                id: id,
                // uid: user.id,
                // gid: user.token.gid,
                // expire: user.token.expire,
                // sign: user.token.sign,
                // token: user.token.token,
            };
        } else {
            params = {
                id: id,
            };
        }

        const apiURL = this._apiUrlHelper.urlBuilder('video-is-filter', params);
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res: Response) => {
                return res[0];
            }));

    }


    getVideo(user, id): Observable<any> {
        let params;
        params = {
            id: id,
        };
        params["device"] = 1;
        params["region"] = this._storage.GetConfig()["region"] || "GL.";
        const apiURL = this._apiUrlHelper.urlBuilder('video-detail', params);
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res: Response) => {
                return this._videoTransFormer.transformFromVideoService(res[0]);
            }))
    }

    getLastPlay(user, id): Observable<any> {
        let params;
        params = {
            id: id,
        };
        const apiURL = this._apiUrlHelper.urlBuilder('video-last-play', params);
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res[0];
            }))
    }


    /*
    ** user:  用户信息
    ** media：视频或剧集key
    ** autoplay: true为剧集key，false为视频key
    */
    getMedia(user, media, autoPlay = false): Observable<any> {
        let params = {
            id: media,
            lang: this._storage.GetConfig()['lang'],
            usersign: 1
        };
        params["region"] = this._storage.GetConfig()["region"] || "GL.";
        params["device"] = 1;
        params["a"] = autoPlay ? 1 : 0;
        params["isMasterSupport"] = this._utility.canUseMaster ? 1 : 0;
        params["sharpness"] = this._storage.GetConfig()["sharpness"];
        params["line"]  = this._storage.GetConfig()['line']
        const apiURL = this._apiUrlHelper.urlBuilder('video-media', params);
        return this._httpClientHelper.get(apiURL)
            // .pipe(
            //     // delay(200000)
            // )
            .pipe(map((res) => {
                if (res[0] !== null) {
                    return res[0];
                }
                return {};
            }));
    }

    like(id): Observable<any> {
        // if (this.isVoted(id)) {
        //     return of({ message: '您已经递交过了' }).pipe(delay(300));
        // }
        const apiURL = this._apiUrlHelper.urlBuilder('video-like', { videoID: id });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                this.voteRecord(id, 'like');
                return res;
            })).pipe(delay(300));
    }

    pageViewRecord(url):Observable<any> {
        return this._httpClientHelper.getAsyncSubs(this._utility.GetSafeResource(url))
    }

    dislike(id): Observable<any> {
        // if (this.isVoted(id)) {
        //     return of({ message: '您已经递交过了' }).pipe(delay(300));
        // }
        const apiURL = this._apiUrlHelper.urlBuilder('video-dislike', { videoID: id });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                this.voteRecord(id, 'dislike');
                return res;
            })).pipe(delay(300))
    }

    share(vid): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-share', { vid, userActionType: 21 });
        return this._httpClientHelper.get(apiURL)
    }

    isVoted(id) {
        const voteHistory = this._storage.GetItem('voteVideo') ? JSON.parse(this._storage.GetItem('voteVideo')) : [];
        return voteHistory.filter(item => item.id === id).length > 0;
    }

    voteRecord(id, behavior) {
        // if (!this.isVoted(id)) {
        //     let voteHistory = this._storage.GetItem('voteVideo') ? JSON.parse(this._storage.GetItem('voteVideo')) : [];
        //     voteHistory.push({ id: id, behavior: behavior });
        //     voteHistory = voteHistory.slice(-50);
        //     this._storage.SetItem('voteVideo', JSON.stringify(voteHistory));
        // }
    }

    favorite(user, id) {
        const apiURL = this._apiUrlHelper.urlBuilder('video-favorite', {
            videoID: id,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res;
            }))
            .pipe(delay(300))

    }

    purchaseMedia(user, mid) {
        const apiURL = this._apiUrlHelper.urlBuilder('media-purchase', {
            id: mid,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res[0];
            }))
            .pipe(delay(200))

    }

    sendPlayHistory(url,logs) {
        this._httpClientHelper.postAsync(url,"logs="+encodeURIComponent(JSON.stringify(logs)));//.catch((error: any) => Observable.throw('Server error:' + error));
    }
    sendWatched(url) {
        this._httpClientHelper.getAsync(url)
    }

    getPlaylistByLanguage(user, id, taxis = 0, cid = '') {

        const apiURL = this._apiUrlHelper.urlBuilder('languagesplaylist', {
            vid: id,
            lsk: 1,
            taxis: taxis,
            cid,
            // uid: user ? user.id : undefined,
            // gid: user ? user.token.gid : undefined,
            // expire: user ? user.token.expire : undefined,
            // sign: user ? user.token.sign : undefined,
            // token: user ? user.token.token : undefined,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(
                map(res => {
                    const result = {
                        playListType: res[0].playListType,
                        playList: res[0].playList.map(gl => {
                            return {
                                id: gl.id,
                                key: gl.key,
                                title: gl.name,
                                created: gl.updateDate,
                                bought: gl.isBought,
                                isNew: gl.isNew,
                                isLive:gl.isLive
                            };
                        })
                    };
                    return result;
                }))
    }

    getStatistics(key) {
        const apiURL = this._apiUrlHelper.urlBuilder('video-statistics', {
            id: key
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res;
            }))
    }

    getPopularityTrend(key, type = 0) {
        const apiURL = this._apiUrlHelper.urlBuilder('video-popularity-trend', {
            id: key,
            showtype: type
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res;
            }));
    }

    getShortVideoList(label: string, size = 8, IsIndex = 1) {
        const apiURL = this._apiUrlHelper.urlBuilder('short-video-list', {
            label,
            size,
            IsIndex
        });

        return this._httpClientHelper.get(apiURL).pipe(
            map(r => {
                return r.map(item => {
                    item.lastseconds = item.lastseconds.split('.')[0]
                    return item;
                })
            })
        )
    }

    getRecommendedShortVideoList(cid: any) {
        let url = this._utility.GetHost("https://upload.{Host}/api/home/GetSubList");
        if (cid) {
            url = url + `?cid=${cid}`
        }
        return this._httpClientHelper.get(url)
    }

    getMostPopularPublishers(label: string, size = 12,) {
        const apiURL = this._apiUrlHelper.urlBuilder('most-popular-publishers', {
            label,
            size,
        });
        return this._httpClientHelper.get(apiURL);
    }

    getRatingList(key) {
        const apiURL = this._apiUrlHelper.urlBuilder('get-rating-list', {
            id: key,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res;
            }));
    }
}
